import {
  AddressingType,
  ApartmentDTO,
  ApartmentInvitationDTO,
  ApartmentInvitationStatusEnum,
  EntrancePlantDetailDTO,
} from '@/../client-generator/generated-clients/plants';
import plantsClient from '@/core/services/plants';
import { SET_APP_LOADING } from '@/core/store/action-types';
import { PropType } from 'vue';
import { Options, Vue } from 'vue-class-component';
import { mapState } from 'vuex';

@Options({
  name: 'DialogMassiveInviteResidents',
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    apartment: {
      type: Object as PropType<ApartmentDTO>,
      required: true,
    },
  },
  computed: {
    ...mapState(['currentEntrancePlant']),
  },
  watch: {
    isVisible: function (newValue) {
      this.isDialogVisible = newValue;
      if (this.isDialogVisible) {
        this.initInvitation();
      }
    },
  },
  components: {},
  emits: ['hide-dialog', 'update-list'],
})
export default class DialogMassiveInviteResidents extends Vue {
  currentEntrancePlant!: EntrancePlantDetailDTO;
  isVisible!: boolean;
  apartment!: ApartmentDTO;
  isDialogVisible = false;
  invite: ApartmentInvitationDTO = new ApartmentInvitationDTO();
  invalidEmail = false;

  get errorLabel() {
    if (this.invalidEmail)
      return this.$t('AppResourceEP.InputNotValid');
    else return '';
  }

  get isCallingCode () {
    return this.currentEntrancePlant.addressingType === AddressingType.DirectCall_Alphanumeric ||
      this.currentEntrancePlant.addressingType === AddressingType.DirectCall_NumbersOnly;
  }

  get isBrfa() {
    return this.currentEntrancePlant.addressingType === AddressingType.BuildingRiserFloorApartment;
  }

  mounted() {
    this.isDialogVisible = this.isVisible;
  }

  handleHideDialog() {
    this.isDialogVisible = false;
  }

  doHideDialog() {
    this.$emit('hide-dialog');
  }

  apartmentInputLabel(apartment: ApartmentDTO) {
    if (this.isBrfa) {
      return this.apartment.code?.replaceAll('|', ' ');
    }

    const baseLabel = `${apartment.name}`;
    if (apartment.labels && apartment.labels?.length > 0) {
      const label = apartment.labels[0];
      if (this.isCallingCode) {
        let labelText = label.callingCode ?? '';
  
        if (label.isPrivate && (label.surname || label.name)) {
          labelText += ` |`;
          labelText += ` ${label.surname ?? ''}`;
          labelText += ` ${label.name ?? ''}`;
        } else if (!label.isPrivate && label.companyName) {
          labelText += ` | ${label.companyName ?? ''}`;
        }
  
        return `${baseLabel} - ${labelText}`;
      }
  
      if (label.isPrivate) {
        return `${baseLabel} - ${label.surname ?? ''} ${label.name ?? ''}`;
      } else {
        return `${baseLabel} - ${label.companyName}`;
      }
    } else {
      return baseLabel;
    }
  }

  initInvitation() {
    this.invite = new ApartmentInvitationDTO({
      apartmentId: this.apartment.apartmentId,
      email: '',
      name: this.apartment.name,
      status: ApartmentInvitationStatusEnum.Pending,
    });
  }

  async handleButtonSubmitAction() {
    this.verifyEmail();
    if (this.invalidEmail) {
      return;
    }

    this.handleHideDialog();

    await this.sendInvite();
  }

  verifyEmail() {
    this.invalidEmail = !this.validateEmail(this.invite.email)
  }

  validateEmail(email?: string) {
    if (!email || email.trim() === '') {
      return false;
    }
    const re = /\S+@\S+/;
    return re.test(email);
  }

  async sendInvite() {
    this.$store.dispatch(SET_APP_LOADING, true);
    try {
      //api
      await plantsClient.residentinvitationPOST(
        this.currentEntrancePlant.desktopId!,
        this.invite
      );

      this.$emit('update-list');
      
      this.$toast.add({
        severity: 'success',
        summary: this.$t('AppResourceEP.InvitationSent'),
        closable: false,
        life: 3000,
      });
    } catch (error) {
      console.log(error);
      this.$toast.add({
        severity: 'error',
        summary:  this.$t('entrancePlant.invitationErrorEmailValidation'),
        closable: false,
        life: 3000,
      });
    } finally {
      this.$store.dispatch(SET_APP_LOADING, false);
    }
  }
}
